
export const TitleBar = {
    title: 'Danh sách bán hàng',
    addButtonText: 'Tạo mới đơn hàng sản phẩm',
};

export const CreateProductOrderTitleBar = {
    title: 'Tạo mới đơn hàng sản phẩm',
    addButtonText: 'Tạo mới đơn hàng sản phẩm',
};

export const Search = {
    searchText: 'Tìm kiếm theo từ khoá Mã đơn hàng, Mã PO, Tên khách hàng',
};

export const Filter = {
    filterText: 'Bộ lọc',
    filterTitle: 'Lựa chọn và áp dụng bộ lọc để hiển thị thông tin tìm kiếm',
};

export const Sort = {
    sortText: 'Sắp xếp:',
    sortButtonText: 'Ngày đến hạn gần nhất',
};

export interface ColumnAttribute {
    text: string;
    icon: any;
    width?: string;
    sx?: Record<string, any>;
    sticky?: boolean;
}

export const TableColumns = [
    { text: 'Mã đơn hàng', icon: <></> },
    { text: 'Mã PO', icon: <></> },
    { text: 'Loại đơn', icon: <></> },
    { text: 'Lệnh Sản Xuất', icon: <></> },
    { text: "Ngày tạo", icon: <></> },
    { text: 'Khách hàng', icon: <></> },
    { text: 'Loại sản phẩm', icon: <></> },
    { text: 'Ngày đến hạn', icon: <></> },
    { text: 'Trạng thái', icon: <></> },
    { text: 'Trạng thái chi tiết', icon: <></> },
    { text: 'Giá', icon: <></> },
    { text: 'Ngày cập nhật', icon: <></> },
    // { text: "Phụ trách", icon: <></> },
];

export const ReserveProductTableColumns = [
    { text: "Mã sản phẩm", icon: <></> },
    { text: "Tên sản phẩm", icon: <></> },
    { text: "Danh mục", icon: <></> },
    { text: "Số lượng sản xuất", icon: <></> },
    { text: "", icon: <></> },
];

export const PaginationBarConfig = {
    text: 'Hiển thị',
    page: 'Trong',
};

export const ProductOrderProductTableColumns = [
    { text: 'Mã sản phẩm', icon: <></>, sticky: true },
    { text: 'Tên sản phẩm', icon: <></>, sticky: true },
    { text: 'Giá bán', icon: <></>, sticky: true, width: '180px' },
    { text: 'Chiết khấu (%)', icon: <></> },
    { text: 'Thuế suất (%)', icon: <></> },
    { text: 'Giá sau chiết khấu', icon: <></> },
    { text: 'Tồn kho', icon: <></> },
    { text: 'Số lượng yêu cầu', icon: <></> },
    { text: 'Số lượng thiếu', icon: <></> },
    { text: '', icon: <></> },
];

export const OpenStateProductTableColumns = [
    { text: 'Mã sản phẩm', icon: <></> },
    { text: 'Tên sản phẩm', icon: <></> },
    { text: 'Giá bán', icon: <></>, width: '180px' },
    { text: 'Tồn kho', icon: <></> },
    { text: 'Số lượng yêu cầu', icon: <></> },
    { text: 'Số lượng thiếu', icon: <></> },
    { text: '', icon: <></> },
];

export const ProductCustomerAddonTableColumns = [
    { text: 'Mã dịch vụ', icon: <></> },
    { text: 'Tên dịch vụ', icon: <></> },
    { text: 'Số lượng', icon: <></> },
    { text: 'Giá tiền', icon: <></> },
    { text: '', icon: <></> },
];

export const ImportMissingProductTableColumn = [
    { text: 'Mã sản phẩm', icon: <></> },
    { text: 'Tên sản phẩm', icon: <></> },
    { text: 'Số lượng thiếu', icon: <></> },
    { text: 'Số lượng nhập kho', icon: <></> },
    { text: '', icon: <></> },
];

export const ImportMissingMaterialTableColumn = [
    { text: 'Mã vật tư', icon: <></> },
    { text: 'Tên vật tư', icon: <></> },
    { text: 'Nhà cung cấp', icon: <></> },
    { text: 'Số lượng thiếu', icon: <></> },
    { text: 'Số lượng nhập kho', icon: <></> },
    { text: 'Ngày đến hạn', icon: <></> },
    { text: '', icon: <></> },
];

export const MissingProductTableColumn = [
    { text: 'Mã sản phẩm', icon: <></> },
    { text: 'Tên sản phẩm', icon: <></> },
    { text: 'Số lượng cần nhập', icon: <></> },
    { text: 'Số lượng nhập kho', icon: <></> },
];

export const MissingMaterialTableColumn = [
    { text: 'Mã vật tư', icon: <></> },
    { text: 'Tên vật tư', icon: <></> },
    { text: 'Số lượng cần nhập', icon: <></> },
    { text: 'Ngày đến hạn', icon: <></> },
    { text: 'Số lượng nhập kho', icon: <></> },
];

export const WarningDeclineProductOrder = {
    title: "Hủy đơn bán hàng",
    context: ["Bạn có chắc chắn muốn hủy đơn bán hàng này không? Hành động này sẽ không được hoàn tác"],
    reason: "Lý do hủy đơn hàng",
};
